import { Box, Button, Grid } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useState } from "react";
import { ShowHideList, yesNoList } from "../../../common/Common";
import { styled, useTheme } from "@mui/material/styles";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";

interface IGeneralSettingsInfoSetupFieldsSecondPanel {
	formMethods: any;
	logo: (value: string | null) => void;
}

const VisuallyHiddenInput = styled("input")({
	clip: "rect(0 0 0 0)",
	clipPath: "inset(50%)",
	height: 1,
	overflow: "hidden",
	position: "absolute",
	bottom: 0,
	left: 0,
	whiteSpace: "nowrap",
	width: 1,
});
export const GeneralSettingsInfoSetupFieldsSecondPanel: FC<
	IGeneralSettingsInfoSetupFieldsSecondPanel
> = ({ formMethods, logo }) => {
	const theme = useTheme();
	const [base64Logo, setBase64Logo] = useState<string | null>(null);
	const onUploadLogo = (event: any) => {

		const file = event.target.files?.[0];
		if (file) {
			const reader = new FileReader();
			reader.onloadend = () => {
				const base64 = reader.result as string;
				setBase64Logo(base64);
				const cleanBase64 = base64.split(",")[1];
				logo(cleanBase64);
			};
			reader.readAsDataURL(file);
		}
	};

	const handleCancelLogo = () => {
		setBase64Logo(null);
		logo(null);
		formMethods.setValue("logo", undefined);
	};
	return (
		<div>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{ mt: .4, mb: 4 }}
			>
				<Grid size={{ xs: 0, sm: 0, md: 4, lg: 4, xl: 4 }}>
					<p
						style={{
							marginTop: 0,
							color: "rgba(0, 0, 0, 0.6)",
							fontSize: ".875rem",
						}}
					>
						Company Logo
					</p>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}>
					<Box sx={{ display: "felx" }}>
						<Button
							component="label"
							role={undefined}
							variant="contained"
							tabIndex={-1}
							startIcon={<CloudUploadIcon />}
							sx={{
								padding: "0px 7px 0px 10px",
								fontSize: "small",
								background: theme.palette.primary.main,
							}}
						>
							Upload Logo
							<VisuallyHiddenInput
								id="logo"
								type="file"
								accept="image/*"
								{...formMethods.register("logo")}
								onChange={onUploadLogo}
							/>
						</Button>
						<Button
							variant="outlined"
							color="error"
							onClick={handleCancelLogo}
							style={{
								padding: "0px 7px 0px 10px",
								fontSize: "small",
								marginLeft: "10px",
							}}
						>
							Cancel
						</Button>
					</Box>
					<div
						style={{
							// border: "1px solid #000",
							// borderRadius: "5px",
							// padding: "1rem",
							// marginTop: "1rem",
							// height: "300px",
							border: "1px solid #000",
							borderRadius: "5px",
							padding: "1rem",
							marginTop: "1rem",
							width: "143px",
							height: "59px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							overflow: "hidden",
							backgroundColor: "#f9f9f9",
						}}
					>
						{base64Logo && (
							<img
								src={base64Logo}
								alt="Preview"
								// style={{ maxWidth: "100%", maxHeight: "100%" }}
								style={{ width: "143px", height: "59px", objectFit: "contain" }}
							/>
						)}
					</div>
				</Grid>
			</Grid>
			<EnhancedDropDownRHFWithLabel
				selectName="bonus"
				label="Bonus"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Non-Periodic-Payment`}
				items={ShowHideList}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="nonPeriodicPayment"
				label="Non-Periodic Payment"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Non-Periodic-Payment`}
				items={ShowHideList}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="retroactivePayIncrease"
				label="Retroactive Pay Increase"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Retroactive-Pay-Increase`}
				items={ShowHideList}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="edrFields"
				label="E/D/R Fields"
				labelPosition={LabelPosition.Top}
				// required
				testId={`E/D/R-Fields`}
				items={ShowHideList}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="hourlyPayRate"
				label="Hourly Pay Rate"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Hourly-Pay-Rate`}
				items={ShowHideList}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="overtimeHours"
				label="Overtime Hours"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Overtime-Hours`}
				items={[
					{ label: "Hide Both", value: 100 },
					{ label: "Show Both", value: 200 },
					{ label: "Show 1.5 Only", value: 300 },
					{ label: "Show 2.0 Only", value: 400 },
				]}
				selectedItem={300}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="employeeSelectionInPayroll"
				label="Employee Selection in Top Panel"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Employee-Selection-in-Top-Panel`}
				items={yesNoList}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<RHookFormNumberFieldWithLabel
				id="regularDailyHoursForEmployees"
				label="Regular daily hours for employees"
				testId={`regular_daily_hours_for_employees`}
			/>
		</div>
	);
};
